import {
  createRouter,
  createWebHistory
} from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import SolucoesComponent from '@/components/SolucoesComponent.vue';
import ContatoComponent from '@/components/ContatoComponent.vue';
import SobreComponent from '@/components/SobreComponent.vue';
import PoliticaPrivacidadeComponent from '@/components/PoliticaPrivacidadeComponent.vue';

const routes = [{
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/solucoes',
    name: 'Solucoes',
    component: SolucoesComponent
  },
  {
    path: '/sobre',
    name: 'Sobre',
    component: SobreComponent
  },
  {
    path: '/contato',
    name: 'Contato',
    component: ContatoComponent
  },
  {
    path: '/politica-de-privacidade',
    name: 'Politica',
    component: PoliticaPrivacidadeComponent
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;